import React, { useState } from 'react';
import { Data, DataState } from '../../types/data-providers';
import * as ApiRequests from '../../api/requests';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { GenericNotOkResponse, ManageAlarmsFilterDetailsOkResponse } from '../../api/types';
import { ApiResponse } from '../../api/api-request-helpers';

type AlarmFilterData = {
    alarmFilter: Data<any>;
    getAlarmFilterData: Function;
};
const Context = React.createContext<AlarmFilterData | null>(null);

function useAlarmFilterData(): AlarmFilterData {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useAlarmFilterData must be used within a AlarmFilterProvider');
    }
    return contextState;
}

const AlarmFilterProvider: React.FC<{ organizationId: string; userId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const [alarmFilter, setAlarmFilter] = useState<Data<any>>({ state: DataState.Loading });
    const getDataByAPI = async (
        organizationId: string,
        userId: string
    ): Promise<ApiResponse<ManageAlarmsFilterDetailsOkResponse, GenericNotOkResponse>> => {
        const alarmFiltersResult = await ApiRequests.getAlarmFilters(
            {
                organizationId: organizationId,
                userId: userId,
            },

            { authHelper }
        );
        return alarmFiltersResult;
    };
    const getAlarmFilterData = async (organizationId: string, userId: string): Promise<void> => {
        setAlarmFilter({
            state: DataState.Loading,
        });
        const alarmFilterResult = await getDataByAPI(organizationId, userId);
        const result = alarmFilterResult.ok
            ? setAlarmFilter({
                  state: DataState.Loaded,
                  value: alarmFilterResult.response.value.data,
              })
            : setAlarmFilter({
                  state: DataState.Error,
                  errorMessage: ApiRequests.extractErrorCodeWithMessage(alarmFilterResult.response),
              });
        return result;
    };

    return <Context.Provider value={{ alarmFilter, getAlarmFilterData }}>{props.children}</Context.Provider>;
};

const TestStarfishChildDeviceDataProvider: React.FC<{ value: AlarmFilterData }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { AlarmFilterProvider, TestStarfishChildDeviceDataProvider, useAlarmFilterData };
